import { render, staticRenderFns } from "./myJoin.vue?vue&type=template&id=4ab20d07&scoped=true"
import script from "./myJoin.vue?vue&type=script&lang=js"
export * from "./myJoin.vue?vue&type=script&lang=js"
import style0 from "./myJoin.vue?vue&type=style&index=0&id=4ab20d07&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab20d07",
  null
  
)

export default component.exports